import React from 'react';

const TaxExclusionModal = ({
  isOpen,
  onClose,
  taxes = [],
  excludedTaxIds = [],
  onChange,
  disabled = false,
}) => {
  if (!isOpen) return null;
  const excludedSet = new Set(
    (excludedTaxIds || []).map((id) => Number(id)).filter((id) => Number.isFinite(id))
  );

  const handleToggle = (taxId) => {
    if (disabled) return;
    const next = new Set(excludedSet);
    if (next.has(taxId)) {
      next.delete(taxId);
    } else {
      next.add(taxId);
    }
    onChange?.(Array.from(next));
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 px-4 py-6 overflow-y-auto"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-xl w-full max-w-lg p-4 space-y-4"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-lg font-semibold">Excluir impuestos</h2>
            <p className="text-xs text-gray-500">
              Selecciona los impuestos que no se aplicaran en este documento.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-600 hover:text-gray-900 bg-white border border-gray-200 rounded-full w-8 h-8 flex items-center justify-center"
          >
            ✕
          </button>
        </div>

        <div className="space-y-2">
          {taxes.length === 0 && (
            <p className="text-sm text-gray-500">No hay impuestos activos en esta sucursal.</p>
          )}
          {taxes.map((tax) => (
            <label key={tax.id} className="flex items-center gap-2 text-sm text-gray-700">
              <input
                type="checkbox"
                checked={excludedSet.has(Number(tax.id))}
                onChange={() => handleToggle(Number(tax.id))}
                disabled={disabled}
              />
              {tax.name} ({Number(tax.rate || 0)}%)
            </label>
          ))}
        </div>

        <div className="flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-60"
            disabled={disabled}
          >
            Listo
          </button>
        </div>
      </div>
    </div>
  );
};

export default TaxExclusionModal;
